// @ts-check

/** @type import("../../../types/images").Image */
export default {};
